import styled from 'styled-components';
import { colors, typography, spacing, borderRadius, shadows, breakpoints } from '../../styles/theme';
import { fadeInUp } from '../../styles/animations';

export const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => (props.$size === 'sm' ? spacing.md : spacing.lg)};
  margin-bottom: ${props => (props.$size === 'sm' ? spacing.lg : spacing['2xl'])};

  &:last-child {
    margin-bottom: 0;
  }
`;

export const GroupTitle = styled.h3`
  font-size: ${props => (props.$size === 'sm' ? typography.fontSize.xl : typography.fontSize['2xl'])};
  font-weight: ${typography.fontWeight.bold};
  color: ${colors.primary.teal};
  margin: 0;
  text-align: center;

  @media (max-width: ${breakpoints.md}) {
    font-size: ${typography.fontSize.xl};
  }
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.md};
  max-width: 800px;
  margin: 0 auto;
  width: 100%;
`;

export const StepItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${spacing.md};
  padding: ${props => (props.$size === 'sm' ? spacing.lg : spacing.xl)};
  background: ${colors.neutral.white};
  border-radius: ${borderRadius['2xl']};
  box-shadow: ${shadows.card};
  // backwards (not both) fill: entrance anim only fills during the delay so the
  // completed animation does not pin transform and kill the hover lift.
  animation: ${fadeInUp} 0.6s ease-out backwards;
  transition: all 0.3s ease;

  &:hover {
    transform: translateX(5px);
    box-shadow: ${shadows.cardHover};
  }

  @media (max-width: ${breakpoints.md}) {
    padding: ${spacing.lg};
  }
`;

export const StepNumber = styled.div`
  width: ${props => (props.$size === 'sm' ? '38px' : '48px')};
  height: ${props => (props.$size === 'sm' ? '38px' : '48px')};
  min-width: ${props => (props.$size === 'sm' ? '38px' : '48px')};
  border-radius: ${borderRadius.full};
  background: ${colors.gradients.orange};
  color: ${colors.neutral.white};
  font-size: ${props => (props.$size === 'sm' ? typography.fontSize.base : typography.fontSize.lg)};
  font-weight: ${typography.fontWeight.extrabold};
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: ${shadows.orange};
`;

export const StepContent = styled.div`
  flex: 1;
`;

export const StepTitle = styled.h4`
  font-size: ${props => (props.$size === 'sm' ? typography.fontSize.base : typography.fontSize.lg)};
  font-weight: ${typography.fontWeight.bold};
  color: ${colors.primary.teal};
  margin: 0 0 ${spacing.xs} 0;
`;

export const StepDescription = styled.p`
  font-size: ${typography.fontSize.base};
  color: ${colors.neutral.gray600};
  line-height: ${typography.lineHeight.relaxed};
  margin: 0;
`;
